<!-- 需求执行 -->
<template>
  <div>
    <!-- 搜索 -->
    <!-- <div class="search-box">
      <el-form :model="listQuery" class="search-form" size="small">
        <el-form-item label="需求计划名称：">
          <el-input
            v-model.trim="listQuery.purchaseDemandName"
            placeholder="请输入需求计划名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="需求计划编号：">
          <el-input
            v-model.trim="listQuery.purchaseDemandCode"
            placeholder="请输入需求计划编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建日期：" label-width="112px" prop="salesScopeId">
          <el-date-picker
            v-model="listQuery.submitTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label-width="112px" label="物料描述：">
          <el-input v-model.trim="listQuery.categoryDesc" placeholder="请输入物料描述"></el-input>
        </el-form-item>
      </el-form>
      <div class="search-btn">
        <div class="btn reset-btn" size="small" @click="handleReset">重置</div>
        <div class="btn submit-btn" size="small" @click="handleQuery">查询</div>
      </div>
    </div> -->
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <!-- <div class="handle-box">
      <el-button
        :disabled="!selectList.length"
        class="default-btn btn"
        @click="goUrl('/demand/execute/choose')"
      >
        选品下单
      </el-button>
      <el-button
        :disabled="!selectList.length"
        class="default-btn btn"
        @click="goUrl('/enquiryManage/enquiryIss?type=purchaseDemand')"
      >
        询比价
      </el-button>
      <el-button :disabled="!selectList.length" class="default-btn btn" @click="goToUrl">
        自行招标
      </el-button>
      <el-button :disabled="!selectList.length" class="default-btn btn" @click="openBidOrg">
        委托招标
      </el-button>
      <el-button
        :disabled="!selectList.length"
        class="default-btn btn"
        @click="goUrl('/demand/execute/requestOrder')"
      >
        执行框架协议
      </el-button>
    </div>
    <div class="table-box">
      <el-table
        v-loading="tableLoading"
        @selection-change="selectionChange"
        @select="onSelect"
        @select-all="selectAll"
        ref="tableData"
        :row-key="getRowKey"
        :data="tableData"
        border
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          min-width="60"
        ></el-table-column>
        <el-table-column
          prop="categoryName"
          label="物料分类"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryCustomCode"
          label="物料编码"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryDesc"
          label="物料描述"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remainingQuantity"
          label="剩余未采数量"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="purchaseDemandCode"
          label="需求计划编号"
          min-width="220"
          align="center"
        >
          <template #default="scope">
            <span class="table-handle-btn" @click="goDetail(scope.row.purchaseDemandId)">
              {{ scope.row.purchaseDemandCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseDemandName"
          label="需求计划名称"
          min-width="230"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.purchaseDemandName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="采购数量"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createMemberName"
          label="需求申请人"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="180" align="center" fixed="right">
          <template #header>
            <span>操作</span>
            <el-tooltip class="item" effect="dark" placement="top-end">
              <div slot="content">
                未执行采购的需求计划可以退回，
                <br />
                部分采购的需求计划仅支持终止采购。
              </div>
              <div class="icon-question">?</div>
            </el-tooltip>
          </template>
          <template #default="{ row }">
            <span
              @click="openDia('backPurchaseDemand', row)"
              class="table-handle-btn"
              v-if="row.isCanBack === 1"
            >
              退回
            </span>
            <span
              @click="openDia('terminatePurchaseDemand', row)"
              class="table-handle-btn"
              v-if="row.isCanTerminate === 1"
            >
              终止采购
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div> -->
    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn
          type="secondary"
          :disabled="!selectList.length"
          @click="goUrl('/demand/execute/choose')"
        >
          选品下单
        </eui-btn>
        <eui-btn
          type="secondary"
          :disabled="!selectList.length"
          @click="goUrl('/enquiryManage/enquiryIss?type=purchaseDemand')"
        >
          询比价
        </eui-btn>
        <eui-btn
          type="secondary"
          :disabled="!selectList.length"
          @click="goToUrl"
        >
          自行招标
        </eui-btn>
        <eui-btn
          type="secondary"
          :disabled="!selectList.length"
          @click="openBidOrg"
        >
          委托招标
        </eui-btn>
        <eui-btn
          type="secondary"
          :disabled="!selectList.length"
          @click="goUrl('/demand/execute/requestOrder')"
        >
          执行框架协议
        </eui-btn>
      </div>
      <eTableList
        ref="tableRef"
        :table-data="tableData"
        :table-label="tableLabel"
        row-key="purchaseDemandItemId"
        :selection-show="true"
        @handleSelectionChange="selectionChange"
        @handleSelect="onSelect"
        @handleSelectAll="selectAll"
      >
        <template #purchaseDemandCode="tData">
          <span
            class="table-handle-btn"
            @click="goDetail(tData.scope.row.purchaseDemandId)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </span>
        </template>
        <template #purchaseDemandStatus="{ scope }">
          <span>{{
            getPurchaseDemandStatus(scope.row.purchaseDemandStatus)
          }}</span>
        </template>

        <!-- <template #header>
          <span>操作</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">
              未执行采购的需求计划可以退回，
              <br />
              部分采购的需求计划仅支持终止采购。
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template> -->

        <template #header>
          <span>操作</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">
              未执行采购的需求计划可以退回，
              <br />
              部分采购的需求计划仅支持终止采购。
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #handle="{ scope }">
          <eui-btn
            v-if="scope.row.isCanBack === 1"
            type="link"
            font-size="12px"
            @click="openDia('backPurchaseDemand', scope.row)"
          >
            退回
          </eui-btn>
          <eui-btn
            v-if="scope.row.isCanTerminate === 1"
            type="link"
            font-size="12px"
            @click="openDia('terminatePurchaseDemand', scope.row)"
          >
            终止采购
          </eui-btn>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <bidOrg :bid-org-visible.sync="bidOrgVisible" />

    <!-- 弹窗提示 -->
    <prompt-modal
      :prompt-modal-visible="visible"
      :footer="true"
      @close="closeDia"
    >
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>{{ title }}</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>{{ content }}</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia()">取消</el-button>
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleSure()"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>
  </div>
</template>
<script>
import PromptModal from '@/modules/projectA/components/common/promptModal';
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/purchase/index';
import { oldMallBaseUrl, bidDingUrl } from '@/modules/projectA/api/config';
import BidOrg from './components/bidOrg.vue';
import { tableLabel, fieldList } from './components/componentsData.js';
import mixins from '../components/mixins';

export default {
  components: { BidOrg, PromptModal },
  mixins: [mixins],
  data() {
    return {
      tableLabel,
      fieldList,
      title: '',
      visible: false,
      content: '',
      type: '',
      paramsRow: {},

      bidOrgVisible: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        purchaseDemandCode: '',
        purchaseDemandName: '',
        endTime: '',
        startTime: '',
        purchaseDemandStatus: '',
        submitTime: null,
        categoryDesc: '',
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      table: false,
      selectList: [],
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      },
    },
  },
  created() {
    this.cloneListQuery = utils.cloneDeep(this.listQuery);
    this.getList(this.listQuery);
  },
  mounted() {},
  methods: {
    // 委托招标弹窗
    openBidOrg() {
      // this.bidOrgVisible = true;
      window.open(
        `${oldMallBaseUrl}/ecmall/externalLogin/loginPlatform.do?referer=${bidDingUrl}`
      );
      // if(process.env.NODE_ENV=== 'production'){
      //   window.open('https://mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://bidding.epec.com','_blank')
      // }else{
      //   window.open('https://uat-mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://10.230.196.49','_blank')
      // }
    },
    getRowKey(row) {
      return row.purchaseDemandItemId;
    },
    async selectionChange(val) {
      console.log(val, 'selectionChange');
      this.selectList = val;
    },
    // 判断table某一项是否被选中
    async onSelect({ rows, row }) {
      console.log(rows, row, 'onSelect');
      const selected = rows.length && rows.indexOf(row) !== -1;
      const { purchaseDemandItemId } = row;
      const isSelected = selected ? 1 : 0;

      this.tableLoading = false;
      const res = await Api.choosePurchaseDemandItemPc({
        purchaseDemandItemId,
        isSelected,
      });
      this.tableLoading = false;
      if (res.code === '200') {
        this.getList(this.listQuery);
      }
    },

    // 点击全选复选框
    async selectAll(val) {
      console.log(val, 'selectAll');
      if (val.length) {
        const isSelectedList = val.filter((item) => item.isSelected === 0);
        for (const item of isSelectedList) {
          const res = await Api.choosePurchaseDemandItemPc({
            purchaseDemandItemId: item.purchaseDemandItemId,
            isSelected: 1,
          });
        }
      } else {
        for (const item of this.tableData) {
          const res = await Api.choosePurchaseDemandItemPc({
            purchaseDemandItemId: item.purchaseDemandItemId,
            isSelected: 0,
          });
        }
      }
      this.getList(this.listQuery);
    },

    toggleSelection(row) {
      if (row) {
        this.$refs.tableRef.$refs.table.toggleRowSelection(row, true);
        /* rows.forEach(row => {
          this.$refs.tableData.toggleRowSelection(row, true);
        }); */
      } else {
        this.$refs.tableRef.$refs.table.clearSelection();
      }
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      // choosePurchaseDemandItem
      Api.queryPurchaseDemandItemPc(params).then((res) => {
        console.log(res);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          console.log(data.records);
          this.tableData = [...data.records];
          console.log(this.tableData);
          this.total = data?.total;
          this.$refs.tableRef.$refs.table.clearSelection();
          this.tableData.forEach((item) => {
            if (item.isSelected === 1) {
              this.toggleSelection(item);
            }
          });
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    // 修改/新增
    goUrl(url) {
      this.$router.push({
        path: url,
      });
    },

    goToUrl() {
      let url = '';
      const { NODE_ENV } = process.env;
      const query = encodeURIComponent('purchaseDemand');
      switch (NODE_ENV) {
        case 'development':
          url = `http://uat-bid.epec.com:3002/projectA/#/bidding/purchaseNewBidding?type=${query}`;
          break;
        case 'fix':
          url = `http://bugfix-bid.epec.com/projectA/#/bidding/purchaseNewBidding?type=${query}`;
          break;
        case 'uat':
          url = `http://uat-bid.epec.com/projectA/#/bidding/purchaseNewBidding?type=${query}`;
          break;
        default:
          url = `http://bid.epec.com/projectA/#/bidding/purchaseNewBidding?type=${query}`;
      }
      window.open(url);
    },

    goDetail(purchaseDemandId) {
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },

    openDia(type, row) {
      this.type = type;
      this.paramsRow = { ...row };
      if (type === 'backPurchaseDemand') {
        this.title = '退回确认';
        this.content =
          '将该需求计划整单退回，退回后可在需求计划提报页面进行重新编辑或删除，确认操作吗？';
      }
      if (type === 'terminatePurchaseDemand') {
        this.title = '终止采购确认';
        this.content = '终止采购后，该需求计划行将无法继续执行，确认操作吗？';
      }
      this.visible = true;
    },

    async handleSure() {
      const { purchaseCompanyId, purchaseDemandId, purchaseDemandItemId } =
        this.paramsRow;
      console.log(purchaseCompanyId, purchaseDemandId, purchaseDemandItemId);
      const res = await Api[this.type]({
        purchaseCompanyId,
        purchaseDemandId,
        purchaseDemandItemId,
      });
      console.log(res.code, this.type);
      if (res.code === '200') {
        if (this.type === 'backPurchaseDemand') {
          this.$message.success('退回成功');
        }
        if (this.type === 'terminatePurchaseDemand') {
          this.$message.success('终止采购成功');
        }
        this.getList(this.listQuery);
        this.closeDia();
      }
    },

    closeDia() {
      this.visible = false;
      this.title = '';
      this.content = '';
      this.paramsRow = {};
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
  &:hover {
    color: #fff;
    background-color: #c5c5c5;
  }
}
.btn {
  min-width: 80px;
  padding: 0 10px;
  text-align: center;
  height: 30px;
  line-height: 27px;
  cursor: pointer;
  border-radius: 0;
}
.requirement-submit {
  padding: 20px;
  background: #fff;
  margin-left: 10px;
  flex: 1;
  flex-direction: column;

  .tab-box {
    display: flex;
    align-items: center;

    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;

      &:last-child {
        border-right: 1px solid #d9d9d9;
      }

      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }

  .search-box {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    position: relative;
    top: -1px;

    .search-form {
      display: flex;
      flex-wrap: wrap;

      .el-form-item {
        flex: 0 0 316px;
      }

      ::v-deep .el-input {
        width: 200px;

        .el-input__inner {
          border-radius: 0;
        }
      }

      ::v-deep .el-date-editor {
        border-radius: 0;
      }
    }

    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;

        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }

      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;

        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }

  .handle-box {
    display: flex;
    margin: 10px 0;

    .default-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }

    .right {
      float: right;
    }
  }

  .table-box {
    .table-handle-btn {
      color: #0064c8;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .err-btn {
      color: #f0250f;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;

    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }

      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }

      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }

      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }

      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;

          &:first-child {
            margin-left: 0;
          }

          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep .cell {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  ::v-deep .el-table__header-wrapper {
    height: 40px;
    background: #f5f5f5;
  }

  ::v-deep .el-table__body-wrapper {
    .empty {
      text-align: center;
      margin-bottom: 80px;

      img {
        margin-top: 60px;
        width: 204px;
        height: 124px;
      }

      p {
        height: 24px;
        line-height: 24px;
        margin-top: 10px;
        color: #333;
        font-size: 16px;

        span {
          color: #2587ff;
          cursor: pointer;
        }
      }
    }
  }

  ::v-deep .el-table th {
    padding: 0;
    height: 40px;
    background: #f5f5f5;
  }

  ::v-deep .el-table td {
    padding: 0;
    height: 50px;
  }

  .prompt-modal-title {
    display: flex;
    height: 40px;
    padding-left: 20px;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: $c3;
      line-height: 14px;
    }
  }

  .prompt-modal-content {
    > h4 {
      font-weight: 500;
      color: $c3;
      margin-bottom: 5px;
    }
  }
}
</style>
